// Copyright 2016 Sorama B.V.

// parseUri 1.2.2
// (c) Steven Levithan <stevenlevithan.com>
// MIT License

export class Uri {
    public source: string;
    public protocol: string;
    public authority: string;
    public userInfo: string;
    public user: string;
    public password: string;
    public host: string;
    public port: string;
    public relative: string;
    public path: string;
    public directory: string;
    public file: string;
    public query: string;
    public anchor: string;
}

/**
 * To be more stringent in adhering to RFC 3986 (which reserves !, ', (, ), and *), even though these characters have no formalized URI delimiting uses, the following can be safely used:
 * Source: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURIComponent
 */
export function fixedEncodeURIComponent(str) {
    return encodeURIComponent(str).replace(/[\.!'()*]/g, function (c) {
        return "%" + c.charCodeAt(0).toString(16);
    });
}

export function parseUri(str: string): Uri {
    const o = options;
    const m = o.strictMode ? o.parser.strict.exec(str) : o.parser.loose.exec(str);
    let uri: unknown = {},
        i = 14;

    while (i--) uri[o.key[i]] = m[i] || "";

    uri[o.q.name] = {};
    uri[o.key[12]].replace(o.q.parser, function ($0: unknown, $1: unknown, $2: unknown) {
        if ($1) uri[o.q.name][$1] = $2;
    });

    return <Uri>uri;
}

/**
 * Builds a query string from the properties of an object.
 * Uses property names as query keys and property values as query values.
 * Does NOT include a key/value pair if the value of that key is undefined.
 * Does include a key/value pair if the value of that key is null.
 * @param data The object representing the key/values to build the query string with.
 */
export function buildQueryString(data: object): string {
    const queryStringParts: string[] = [];

    for (const d in data) {
        if (Object.prototype.hasOwnProperty.call(data, d) && data[d] !== undefined) {
            queryStringParts.push(encodeURIComponent(d) + "=" + encodeURIComponent(data[d]));
        }
    }

    const queryString = queryStringParts.length > 0 ? "?" + queryStringParts.join("&") : "";

    return queryString;
}

const options = {
    strictMode: false,
    key: [
        "source",
        "protocol",
        "authority",
        "userInfo",
        "user",
        "password",
        "host",
        "port",
        "relative",
        "path",
        "directory",
        "file",
        "query",
        "anchor",
    ],
    q: {
        name: "queryKey",
        parser: /(?:^|&)([^&=]*)=?([^&]*)/g,
    },
    parser: {
        strict: /^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
        loose: /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/,
    },
};
